import { useEffect, useState } from "react"

const useFaqStructured = ({ items, oneAtATime, onClick }) => {
  const [actives, setActives] = useState([])

  const toggleAccordion = (index) => {
    if (actives.includes(index)) {
      const newActives = actives.filter((accordion) => accordion != index)
      setActives(newActives)
      return
    }
    if (oneAtATime) {
      setActives([index])
      return
    }
    const newActives = [...actives]
    newActives.push(index)
    setActives(newActives)
  }

  /**
   * Verifica se todos os itens possuem um index e verifica se não há indexes repetidos
   * @param items Array com os conteúdos dos acordeões
   */
  const checkIndexes = (items) => {
    const indexMap = {}
    items?.forEach((item, i) => {
      if (item.index === undefined) {
        item.index = i + 1
      }
      if (!indexMap[item.index]) {
        indexMap[item.index] = []
      }
      indexMap[item.index].push(i)
    })
    for (const key in indexMap) {
      if (indexMap[key].length > 1) {
        indexMap[key].forEach((itemIndex, i) => {
          items[itemIndex].index = `${items[itemIndex].index}-${i}`
        })
      }
    }
  }

  const handleClick = (callbackSingle, index) => {
    if (onClick) onClick(index)
    if (callbackSingle) callbackSingle(index)
    toggleAccordion(index)
  }

  useEffect(() => {
    checkIndexes(items)
  }, [])

  return {
    actives,
    handleClick,
  }
}

export { useFaqStructured }
